import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface RegulatedBehavioursSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Engages appropriately in social or learning conversations",
  "Participates in class activities",
  "Maintains steady eye contact or relaxed body language",
  "Takes turns and cooperates with peers",
  "Completes tasks independently or with minimal support",
  "Seeks help when needed",
];

export const RegulatedBehavioursSection: React.FC<
  RegulatedBehavioursSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe the student's behaviours when calm."
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="regulatedBehavioursOther">
        Other:
      </label>
      <input
        type="text"
        id="regulatedBehavioursOther"
        name="regulatedBehavioursOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
